import { Box, Skeleton, Stack, useTheme } from '@mui/material';
import { useResponsiveBreakpoints } from 'src/hooks/ueResponsiveBreakpoints';
export default function OrganizationProfessionalCalendarSkeleton() {
  const theme = useTheme();
  const { isSm, isMd, isLg, isXl } = useResponsiveBreakpoints();
  const DayOfWeekCell = (
    <Stack
      sx={{
        gap: 1,
        flexDirection: 'row',
        flex: 1,
        justifyContent: 'center',
      }}
    >
      <Skeleton variant="circular" height="32px" width="60%" />
    </Stack>
  );

  const getHourRow = (cellsToDisplay: boolean[]) => (
    <Stack>
      <Stack>
        <Stack
          sx={{
            flex: 1,
            flexDirection: 'row',
          }}
        >
          <Stack
            height="39px"
            flexDirection="row"
            width="72px"
            justifyContent="space-between"
          >
            <Stack flex={1} alignItems="center">
              <Skeleton
                variant="circular"
                height="24px"
                width="48px"
                sx={{ m: 1 }}
              />
            </Stack>
            <Skeleton variant="rectangular" height="39px" width="1px" />
          </Stack>
          {cellsToDisplay.map((cell, index) => (
            <Stack
              key={index}
              height="39px"
              flexDirection="row"
              flex={1}
              justifyContent="space-between"
            >
              <Stack flex={1} alignItems="center">
                {cell ? (
                  <Skeleton
                    variant="circular"
                    height="24px"
                    width="80%"
                    sx={{ m: 1 }}
                  />
                ) : (
                  <Box height="24px" width="80%" sx={{ m: 1 }} />
                )}
              </Stack>
              {index !== cellsToDisplay.length + 1 && (
                <Skeleton variant="rectangular" height="39px" width="1px" />
              )}
            </Stack>
          ))}
        </Stack>
        <Skeleton variant="rectangular" height="1px" width="100%" />
      </Stack>
    </Stack>
  );

  return (
    <Stack
      sx={{
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
      }}
    >
      <Stack
        direction={!isMd ? 'row' : 'column'}
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: 2.5, pr: 2, position: 'relative', gap: 1 }}
      >
        <Stack
          sx={{
            gap: 1,
            flexDirection: 'row',
            flex: 1,
          }}
        >
          <Skeleton variant="circular" height="32px" width="32px" />
          <Skeleton variant="circular" height="32px" width="32px" />
          <Skeleton variant="circular" height="32px" width="32px" />
        </Stack>
        <Stack
          sx={{
            gap: 1,
            flexDirection: 'row',
            flex: 1,
            justifyContent: 'center',
          }}
        >
          <Skeleton variant="circular" height="32px" width="32px" />
          <Skeleton variant="rounded" height="32px" width="140px" />
          <Skeleton variant="circular" height="32px" width="32px" />
        </Stack>
        <Stack
          sx={{
            gap: 1,
            flexDirection: 'row',
            flex: 1,
            justifyContent: 'flex-end',
          }}
        >
          <Skeleton variant="circular" height="32px" width="59px" />
          <Skeleton variant="rounded" height="32px" width="83px" />
        </Stack>
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ py: 1, pl: 9, bgcolor: theme.palette.grey[300] }}
      >
        {DayOfWeekCell}
        {DayOfWeekCell}
        {DayOfWeekCell}
        {DayOfWeekCell}
        {DayOfWeekCell}
        {DayOfWeekCell}
        {DayOfWeekCell}
      </Stack>
      <Stack>
        {getHourRow([true, true, false, true, true, false, true])}
        {getHourRow([true, false, false, false, true, false, true])}
        {getHourRow([true, false, true, true, false, false, false])}
        {getHourRow([true, true, true, false, true, false, true])}
        {getHourRow([true, false, false, false, false, true, false])}
        {getHourRow([false, false, true, true, true, false, false])}
        {getHourRow([true, false, true, false, true, false, true])}
        {getHourRow([false, false, false, false, true, true, true])}
        {getHourRow([false, false, false, true, false, true, false])}
        {getHourRow([false, true, false, false, false, false, true])}
        {getHourRow([true, false, false, false, true, false, false])}
        {getHourRow([false, true, false, true, true, false, true])}
        {getHourRow([false, true, true, false, false, true, false])}
        {getHourRow([false, true, false, false, true, true, false])}
        {getHourRow([false, true, false, false, false, false, false])}
        {getHourRow([true, true, false, true, true, false, true])}
        {getHourRow([true, false, false, false, true, false, true])}
        {getHourRow([true, false, true, true, false, false, false])}
        {getHourRow([true, true, true, false, true, false, true])}
        {getHourRow([true, false, false, false, false, true, false])}
        {getHourRow([false, false, true, true, true, false, false])}
        {getHourRow([true, false, true, false, true, false, true])}
        {getHourRow([false, false, false, false, true, true, true])}
        {getHourRow([false, false, false, true, false, true, false])}
        {getHourRow([false, true, false, false, false, false, true])}
        {getHourRow([true, false, false, false, true, false, false])}
        {getHourRow([false, true, false, true, true, false, true])}
        {getHourRow([false, true, true, false, false, true, false])}
        {getHourRow([false, true, false, false, true, true, false])}
        {getHourRow([false, true, false, false, false, false, false])}
        {getHourRow([true, true, false, true, true, false, true])}
        {getHourRow([true, false, false, false, true, false, true])}
        {getHourRow([true, false, true, true, false, false, false])}
        {getHourRow([true, true, true, false, true, false, true])}
        {getHourRow([true, false, false, false, false, true, false])}
        {getHourRow([false, false, true, true, true, false, false])}
        {getHourRow([true, false, true, false, true, false, true])}
        {getHourRow([false, false, false, false, true, true, true])}
        {getHourRow([false, false, false, true, false, true, false])}
        {getHourRow([false, true, false, false, false, false, true])}
        {getHourRow([true, false, false, false, true, false, false])}
        {getHourRow([false, true, false, true, true, false, true])}
        {getHourRow([false, true, true, false, false, true, false])}
        {getHourRow([false, true, false, false, true, true, false])}
        {getHourRow([false, true, false, false, false, false, false])}
      </Stack>
    </Stack>
  );
}
